export default {
      id: "showDateLookup-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "assets/webdesktop/web-desktop-sprite.svg#showDateLookup",
      toString: function () {
        return this.url;
      }
    }